import MBanner from "./MBanner.vue";
export default MBanner;
